import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom'
import {
  Logo,
  Adress,
  Search,
  Contact
} from '../../component/home/index'
import Footer from '../../component/common/Footer';
import SearchRouter from '../search';

function Home() {
  let faSearch = window.location.search.split('search=')[1] ? decodeURIComponent(window.location.search.split('search=')[1]) : ''
  let [urlSearch, seturlSearch] = useState(faSearch)

  /* eslint-disable */
  const history = useHistory()
  const onSubmit = useCallback((search?: string) => {
    if (!search) return
    seturlSearch(search)
  }, [seturlSearch])

  useEffect(() => {
  })

  return (
    <div className={`${urlSearch ? '' : ' px-3'}`}>
    {
      // Only the home page of Google search whitelist is configured. So it is compatible with external search。
      urlSearch ?
        <SearchRouter
          urlSearch={urlSearch}
          // backUrl='/webhome'
          onBack={() => { seturlSearch('') }}
        />
        : 
        <div className=' overflow-hidden h-[100vh - 40px]'>
          <Logo />
          <Search
            onSubmit={onSubmit}
          />
          <Contact />
          <Adress iconLink='/webhome' />
          <Footer />
        </div>
    }
    </div>
  );
}

export default Home;
